var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04757 5.99215L6.24849 6.68941L5.72269 6.14276L7.07232 5.05503L8.14564 5.05502V9.00432L7.04757 9.00432V5.99215Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67249 13.1573L7.26695 11.9338C7.64164 11.6237 7.90411 10.9327 7.17746 10.9327C6.84518 10.9327 6.65007 11.1455 6.62583 11.4264H5.72645C5.73844 11.2253 5.78441 10.8956 5.86435 10.7493C6.12825 10.2544 6.69603 10.0801 7.22542 10.0801C7.71867 10.0801 8.26879 10.261 8.49056 10.7383C9.06958 11.9154 7.52613 12.8956 7.11265 13.1573H8.63446V14.0294H5.67249V13.1573Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74322 16.9995C6.9825 16.9995 7.15015 17.0277 7.3738 16.924C7.6239 16.8012 7.66751 16.4594 7.43781 16.2874C7.2482 16.1397 7.03514 16.1288 6.84214 16.2766C6.75292 16.3449 6.69472 16.4294 6.66757 16.5301L5.7074 16.3467C5.75395 16.1813 5.82378 16.041 5.91689 15.9259C6.21342 15.5479 6.71387 15.4295 7.17384 15.4295C7.64922 15.4295 8.20149 15.5721 8.44824 16.0176C8.62668 16.3236 8.72154 16.7592 8.50017 17.0373C8.37991 17.1884 8.17576 17.2936 7.94687 17.3367C8.9188 17.4494 8.94254 18.5616 8.1922 19.0983C7.6459 19.4856 6.75583 19.4723 6.19621 19.1414C5.93241 18.9832 5.75783 18.7332 5.67249 18.3915L6.59192 18.1919C6.65475 18.4686 6.88777 18.6343 7.11265 18.6343C7.60843 18.6343 7.9339 17.9548 7.40943 17.7603C7.1759 17.6736 6.98851 17.7009 6.74322 17.7009V16.9995Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4259 6.53833H18.3277V8.38449H10.4259V6.53833Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4259 11.1537H18.3277V12.9999H10.4259V11.1537Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4259 15.7691H18.3277V17.6153H10.4259V15.7691Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNumber);
export default __webpack_public_path__ + "static/media/list_number.9d99e72e321da1cb81997cdf28d7c43b.svg";
export { ForwardRef as ReactComponent };